export const selectDotsNodes = (state) => state.dots.nodes;
export const selectDotsNodesLoading = (state) => state.dots.nodesLoading;
export const selectDotsBrowserMode = (state) => state.dots.browserMode;
export const selectDotsSelectedTargets = (state) => state.dots.selectedTargets;
export const selectDotsModalActive = (state) => state.dots.modalActive;
export const selectDotsModalData = (state) => state.dots.modalData;
export const selectDotsIteration = (state) => state.dots.iteration;